export const createAction = name => `@@formCreation/${name}`;
export const REQUEST_FORM_CREATION = createAction('REQUEST_FORM_CREATION');
export const SUCCEED_CREATING_FORM = createAction('SUCCEED_CREATING_FORM');
export const FAIL_CREATING_FORM = createAction('FAIL_CREATING_FORM');
export const RESET_FORM_CREATION_STATE = createAction('RESET_FORM_CREATION_STATE');
export const SELECT_FORM_INBOX_ID = createAction('SELECT_FORM_INBOX_ID');